import React from 'react'
import OttomanImage from '../../../../assets/products/ottoman-1-seat.webp'

const OttomanOneSeat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="794"
      height="620"
      viewBox="0 0 794 200"
      fill="none"
    >
      <image
        x="-305"
        y="-390"
        width="1080"
        height="1020"
        transform="scale(0.85)"
        xlinkHref={OttomanImage}
      />
      <g id="Group 1498">
        <g id="C-Comp">
          <g filter="url(#filter0_d_5414_1929)">
            <rect
              id="C-Background"
              x="23.751"
              y="79.7157"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-22.6637 23.751 79.7157)"
              fill="transparent"
            />
            <path
              id="C-Text"
              d="M53.2393 92.9885H55.8672C55.8145 93.8499 55.5771 94.6145 55.1553 95.2825C54.7393 95.9504 54.1562 96.4719 53.4062 96.8469C52.6621 97.2219 51.7656 97.4094 50.7168 97.4094C49.8965 97.4094 49.1611 97.2688 48.5107 96.9875C47.8604 96.7004 47.3037 96.2903 46.8408 95.7571C46.3838 95.2239 46.0352 94.5793 45.7949 93.8235C45.5547 93.0676 45.4346 92.2209 45.4346 91.2834V90.3958C45.4346 89.4583 45.5576 88.6116 45.8037 87.8557C46.0557 87.094 46.4131 86.4465 46.876 85.9133C47.3447 85.3801 47.9043 84.97 48.5547 84.6829C49.2051 84.3958 49.9316 84.2522 50.7344 84.2522C51.8008 84.2522 52.7002 84.4456 53.4326 84.8323C54.1709 85.219 54.7422 85.7522 55.1465 86.4319C55.5566 87.1116 55.8027 87.885 55.8848 88.7522H53.248C53.2188 88.2366 53.1162 87.8 52.9404 87.4426C52.7646 87.0793 52.498 86.8069 52.1406 86.6252C51.7891 86.4377 51.3203 86.344 50.7344 86.344C50.2949 86.344 49.9111 86.426 49.583 86.5901C49.2549 86.7542 48.9795 87.0032 48.7568 87.3372C48.5342 87.6711 48.3672 88.093 48.2559 88.6028C48.1504 89.1067 48.0977 89.6985 48.0977 90.3782V91.2834C48.0977 91.9456 48.1475 92.5286 48.2471 93.0325C48.3467 93.5305 48.499 93.9524 48.7041 94.2981C48.915 94.6379 49.1846 94.8958 49.5127 95.0715C49.8467 95.2415 50.248 95.3264 50.7168 95.3264C51.2676 95.3264 51.7217 95.2385 52.0791 95.0627C52.4365 94.887 52.709 94.6262 52.8965 94.2805C53.0898 93.9348 53.2041 93.5042 53.2393 92.9885Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M57.7808 12.366C57.5254 12.2611 57.2333 12.383 57.1283 12.6385L55.4181 16.8008C55.3132 17.0563 55.4352 17.3484 55.6906 17.4533C55.946 17.5583 56.2382 17.4363 56.3431 17.1809L57.8633 13.481L61.5632 15.0012C61.8186 15.1061 62.1107 14.9841 62.2157 14.7287C62.3206 14.4733 62.1986 14.1811 61.9432 14.0762L57.7808 12.366ZM110.716 140.973C110.972 141.078 111.264 140.956 111.369 140.7L113.079 136.538C113.184 136.283 113.062 135.991 112.806 135.886C112.551 135.781 112.259 135.903 112.154 136.158L110.634 139.858L106.934 138.338C106.678 138.233 106.386 138.355 106.281 138.61C106.176 138.866 106.298 139.158 106.554 139.263L110.716 140.973ZM57.1294 13.0212L58.0815 15.3012L59.0043 14.9159L58.0522 12.6358L57.1294 13.0212ZM59.9856 19.8613L61.8897 24.4213L62.8125 24.036L60.9084 19.4759L59.9856 19.8613ZM63.7939 28.9814L65.698 33.5415L66.6208 33.1561L64.7166 28.5961L63.7939 28.9814ZM67.6021 38.1015L69.5062 42.6616L70.429 42.2763L68.5249 37.7162L67.6021 38.1015ZM71.4103 47.2217L73.3145 51.7817L74.2372 51.3964L72.3331 46.8363L71.4103 47.2217ZM75.2186 56.3418L77.1227 60.9019L78.0455 60.5166L76.1414 55.9565L75.2186 56.3418ZM79.0268 65.4619L80.9309 70.022L81.8537 69.6367L79.9496 65.0766L79.0268 65.4619ZM82.8351 74.5821L84.7392 79.1421L85.662 78.7568L83.7578 74.1968L82.8351 74.5821ZM86.6433 83.7022L88.5474 88.2623L89.4702 87.877L87.5661 83.3169L86.6433 83.7022ZM90.4515 92.8224L92.3557 97.3824L93.2784 96.9971L91.3743 92.437L90.4515 92.8224ZM94.2598 101.942L96.1639 106.503L97.0867 106.117L95.1826 101.557L94.2598 101.942ZM98.068 111.063L99.9721 115.623L100.895 115.237L98.9908 110.677L98.068 111.063ZM101.876 120.183L103.78 124.743L104.703 124.358L102.799 119.797L101.876 120.183ZM105.685 129.303L107.589 133.863L108.511 133.478L106.607 128.918L105.685 129.303ZM109.493 138.423L110.445 140.703L111.368 140.318L110.416 138.038L109.493 138.423Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter1_d_5414_1929)">
            <rect
              id="B-Background"
              x="296.31"
              y="191.753"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 296.31 191.753)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M313.111 168.729L309.824 168.729L309.807 166.918L312.566 166.918C313.053 166.918 313.451 166.857 313.762 166.734C314.072 166.605 314.304 166.42 314.456 166.18C314.614 165.934 314.693 165.635 314.693 165.284C314.693 164.885 314.617 164.563 314.465 164.317C314.318 164.071 314.087 163.892 313.771 163.781C313.46 163.669 313.059 163.614 312.566 163.614L310.738 163.614L310.738 174.345L308.102 174.345L308.102 161.548L312.566 161.548C313.311 161.548 313.976 161.619 314.562 161.759C315.153 161.9 315.654 162.114 316.064 162.401C316.475 162.688 316.788 163.051 317.005 163.491C317.222 163.924 317.33 164.44 317.33 165.038C317.33 165.565 317.21 166.051 316.97 166.497C316.735 166.942 316.363 167.305 315.854 167.586C315.35 167.868 314.69 168.023 313.876 168.052L313.111 168.729ZM312.997 174.345L309.104 174.345L310.132 172.289L312.997 172.289C313.46 172.289 313.838 172.215 314.131 172.069C314.424 171.917 314.641 171.711 314.781 171.454C314.922 171.196 314.992 170.9 314.992 170.566C314.992 170.191 314.928 169.866 314.799 169.59C314.676 169.315 314.477 169.104 314.201 168.958C313.926 168.805 313.563 168.729 313.111 168.729L310.571 168.729L310.589 166.918L313.753 166.918L314.359 167.63C315.139 167.619 315.766 167.756 316.24 168.043C316.721 168.325 317.069 168.691 317.286 169.142C317.509 169.593 317.62 170.077 317.62 170.592C317.62 171.413 317.441 172.104 317.084 172.667C316.727 173.223 316.202 173.642 315.511 173.923C314.825 174.205 313.987 174.345 312.997 174.345Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M152.698 160.17C152.542 160.398 152.6 160.709 152.828 160.865L156.539 163.411C156.766 163.567 157.077 163.509 157.234 163.281C157.39 163.053 157.332 162.742 157.104 162.586L153.805 160.323L156.068 157.025C156.224 156.797 156.166 156.486 155.938 156.33C155.711 156.173 155.4 156.231 155.243 156.459L152.698 160.17ZM459.346 103.755C459.503 103.527 459.445 103.216 459.217 103.06L455.506 100.515C455.278 100.358 454.967 100.416 454.811 100.644C454.655 100.872 454.713 101.183 454.94 101.339L458.239 103.602L455.976 106.9C455.82 107.128 455.878 107.439 456.106 107.596C456.334 107.752 456.645 107.694 456.801 107.466L459.346 103.755ZM153.202 160.944L155.668 160.485L155.485 159.502L153.019 159.961L153.202 160.944ZM160.601 159.566L165.534 158.647L165.35 157.664L160.418 158.583L160.601 159.566ZM170.466 157.728L175.399 156.809L175.216 155.826L170.283 156.745L170.466 157.728ZM180.331 155.89L185.264 154.971L185.081 153.988L180.148 154.907L180.331 155.89ZM190.197 154.052L195.129 153.133L194.946 152.149L190.014 153.069L190.197 154.052ZM200.062 152.214L204.995 151.294L204.812 150.311L199.879 151.23L200.062 152.214ZM209.927 150.375L214.86 149.456L214.677 148.473L209.744 149.392L209.927 150.375ZM219.793 148.537L224.725 147.618L224.542 146.635L219.609 147.554L219.793 148.537ZM229.658 146.699L234.591 145.78L234.407 144.797L229.475 145.716L229.658 146.699ZM239.523 144.861L244.456 143.942L244.273 142.959L239.34 143.878L239.523 144.861ZM249.388 143.023L254.321 142.104L254.138 141.121L249.205 142.04L249.388 143.023ZM259.254 141.185L264.186 140.266L264.003 139.283L259.071 140.202L259.254 141.185ZM269.119 139.347L274.052 138.428L273.869 137.445L268.936 138.364L269.119 139.347ZM278.984 137.509L283.917 136.59L283.734 135.607L278.801 136.526L278.984 137.509ZM288.85 135.671L293.782 134.752L293.599 133.769L288.666 134.688L288.85 135.671ZM298.715 133.833L303.648 132.914L303.464 131.931L298.532 132.85L298.715 133.833ZM308.58 131.995L313.513 131.076L313.33 130.092L308.397 131.012L308.58 131.995ZM318.446 130.157L323.378 129.237L323.195 128.254L318.262 129.173L318.446 130.157ZM328.311 128.318L333.243 127.399L333.06 126.416L328.128 127.335L328.311 128.318ZM338.176 126.48L343.109 125.561L342.926 124.578L337.993 125.497L338.176 126.48ZM348.041 124.642L352.974 123.723L352.791 122.74L347.858 123.659L348.041 124.642ZM357.907 122.804L362.839 121.885L362.656 120.902L357.724 121.821L357.907 122.804ZM367.772 120.966L372.705 120.047L372.521 119.064L367.589 119.983L367.772 120.966ZM377.637 119.128L382.57 118.209L382.387 117.226L377.454 118.145L377.637 119.128ZM387.503 117.29L392.435 116.371L392.252 115.388L387.319 116.307L387.503 117.29ZM397.368 115.452L402.3 114.533L402.117 113.55L397.185 114.469L397.368 115.452ZM407.233 113.614L412.166 112.695L411.983 111.712L407.05 112.631L407.233 113.614ZM417.098 111.776L422.031 110.857L421.848 109.874L416.915 110.793L417.098 111.776ZM426.964 109.938L431.896 109.019L431.713 108.035L426.78 108.955L426.964 109.938ZM436.829 108.1L441.762 107.18L441.578 106.197L436.646 107.116L436.829 108.1ZM446.694 106.261L451.627 105.342L451.444 104.359L446.511 105.278L446.694 106.261ZM456.559 104.423L459.026 103.964L458.843 102.981L456.376 103.44L456.559 104.423Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter2_d_5414_1929)">
            <rect
              id="A-Background"
              x="540.718"
              y="78.6241"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 540.718 78.6241)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M522.701 52.0427L519.221 62.6511H516.417L521.172 49.8542H522.956L522.701 52.0427ZM525.593 62.6511L522.104 52.0427L521.822 49.8542H523.624L528.405 62.6511H525.593ZM525.435 57.8875V59.9529H518.676V57.8875H525.435Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M483.457 74.7944C483.632 75.0085 483.947 75.0406 484.161 74.8661L487.649 72.0232C487.863 71.8487 487.895 71.5338 487.721 71.3197C487.546 71.1057 487.231 71.0736 487.017 71.248L483.916 73.7751L481.389 70.6744C481.215 70.4603 480.9 70.4282 480.686 70.6027C480.472 70.7771 480.44 71.0921 480.614 71.3062L483.457 74.7944ZM488.723 30.1051C488.549 29.8911 488.234 29.859 488.02 30.0334L484.531 32.8764C484.317 33.0508 484.285 33.3658 484.46 33.5798C484.634 33.7939 484.949 33.826 485.163 33.6515L488.264 31.1245L490.791 34.2251C490.965 34.4392 491.28 34.4713 491.494 34.2968C491.708 34.1224 491.74 33.8074 491.566 33.5934L488.723 30.1051ZM484.342 74.5292L484.623 71.7756L483.628 71.6742L483.347 74.4278L484.342 74.5292ZM485.184 66.2684L485.746 60.7612L484.751 60.6598L484.189 66.167L485.184 66.2684ZM486.307 55.2541L486.868 49.7469L485.873 49.6455L485.312 55.1527L486.307 55.2541ZM487.43 44.2397L487.991 38.7325L486.996 38.6311L486.435 44.1383L487.43 44.2397ZM488.552 33.2253L488.833 30.4717L487.838 30.3703L487.557 33.1239L488.552 33.2253Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5414_1929"
          x="-6.24902"
          y="43.9176"
          width="113.632"
          height="113.632"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5414_1929" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5414_1929"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5414_1929"
          x="258.8"
          y="123.937"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5414_1929" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5414_1929"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5414_1929"
          x="469.929"
          y="13.678"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5414_1929" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5414_1929"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default OttomanOneSeat
